





























import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { ProductTabFilterOptions, PageConfig, DateFilterItems } from "@/types";
import { encodeQueryParams } from "@canvas/api/lib/utils";
import ProductTable from "../ProductTable.vue";
import CellRenderer from "../TableRenderers/NameRenderer.vue";
import { formatDateForQuery } from "@/utils";
import InfiniteLoading from "vue-infinite-loading";

const dateOptions = {
  year: "numeric",
  month: "short",
  day: "numeric",
};
export default Vue.extend({
  name: "manage-products",
  components: {
    ProductTable,
    InfiniteLoading,
  },
  data(): { [key: string]: any } {
    return {
      pluginState: null,
      searchData: {
        searchText: "",
        option: "",
      },
      dateFilter: Object.assign(
        DateFilterItems[0],
        {
          displayText: DateFilterItems[0].display_name,
        },
        { start_date: null, end_date: null }
      ),
      historyTableColumns: [
        {
          name: "customer_details",
          display_name: "CUSTOMER DETAILS",
          fixed: false,
          width: 20,
          headrenderer: null,
          cellrenderer: CellRenderer,
        },
        {
          name: "assigned_to",
          display_name: "Assgined To",
          fixed: false,
          width: 25,
          headrenderer: null,
          cellrenderer: CellRenderer,
        },
        {
          name: "date_of_visit",
          display_name: "DATE OF VISIT",
          fixed: false,
          width: 20,
          headrenderer: null,
          cellrenderer: CellRenderer,
        },
        {
          name: "reason",
          display_name: "REASON",
          fixed: false,
          width: 25,
          headrenderer: null,
          cellrenderer: CellRenderer,
        },
        {
          name: "met_client",
          display_name: "Met Client",
          fixed: false,
          width: 10,
          headrenderer: null,
          cellrenderer: CellRenderer,
        },
      ],
    };
  },
  provide(): any {
    return {
      actionHandler: (this as any).handleTableAction,
    };
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement",
      isOnMobileDevice: "isOnMobileDevice",
    }),
    ...mapState("appModule", {
      historyTableData: "visitHistoryDetails",
      selectedEc: "selectedEc",
    }),
  },
  methods: {
    ...mapActions("appModule", ["searchVisitHistory"]),
    updateRoute() {
      let apiQuery = {
        [(this as any).searchData.option.name]: (this as any).searchData
          .searchText,
        limit: (this as any).historyTableData.pageConfig.limit,
        offset: (this as any).historyTableData.pageConfig.offset,
        ec_id__in: (this as any).selectedEc.name,
      };
      if ((this as any).historyTableData.pageConfig.dateFilter) {
        apiQuery = Object.assign(
          apiQuery,
          (this as any).historyTableData.pageConfig.dateFilterQuery
        );
      }
      (this as any).historyTableData.pageConfig.query = encodeQueryParams(
        apiQuery
      );
      const routeLink =
        "/trxnhistory/" +
        JSON.stringify({
          search: (this as any).searchData,
          pageConfig: (this as any).historyTableData.pageConfig,
        });
      (this as any).searchHistory();
      (this as any).$router.push({
        path: routeLink,
      });
    },
    searchHistory() {
      let ctx = this;
      return (this as any)
        .searchVisitHistory(
          Object.assign((this as any).historyTableData.pageConfig, {
            isOnMobileDevice: (this as any).isOnMobileDevice,
          })
        )
        .then((response: any) => {
          if (ctx.isOnMobileDevice && ctx.pluginState) {
            if (response.totalcount <= response.data.length) {
              ctx.pluginState.complete();
            } else {
              ctx.pluginState.loaded();
            }
          }
        });
    },
    handleTableAction(actionType: string, data: any) {
      switch (actionType) {
        case "pageIncrease":
        case "pageDecrease":
        case "goToPage":
          (this as any).historyTableData.pageConfig.offset =
            (this as any).historyTableData.pageConfig.limit * (data - 1);
          (this as any).historyTableData.pageConfig.page = data;
          (this as any).updateRoute();
          break;
        case "setPageLength":
          (this as any).historyTableData.pageConfig.limit = data;
          (this as any).historyTableData.pageConfig.page = 1;
          (this as any).historyTableData.pageConfig.offset = 0;
          (this as any).updateRoute();
          break;
        case "rowselect":
          (this as any).$router.push({
            path: "/search/projects",
            query: {
              pids: String(data.customer_details.project_id),
            },
          });
          break;
        case "setDateFilter":
          //sets the date filter to the selected datefilter type
          (this as any).dateFilter = data;
          (this as any).dateFilter.displayText = (this as any).dateFilter.displayName;
          if (data.name === DateFilterItems[0].name) {
            (this as any).dateFilter = Object.assign(DateFilterItems[0], {
              displayText: DateFilterItems[0].display_name,
            });
            (this as any).historyTableData.pageConfig = JSON.parse(
              JSON.stringify(PageConfig)
            );
            (this as any).historyTableData.pageConfig.dateFilterQuery = "";
            (this as any).updateRoute();
            if ((this as any).isOnMobileDevice) {
              (this as any).$store.commit(
                "appModule/resetStoreVisitHistory",
                null,
                {
                  root: true,
                }
              );
              (this as any).historyTableData.pageConfig = JSON.parse(
                JSON.stringify(PageConfig)
              );
            }
          }
          break;
        case "applyDateFilter":
          //calculate the appropriate date filter when Apply Button is clicked
          (this as any).dateFilter = data;
          (this as any).dateFilter.displayText = (this as any).dateFilter.displayName;
          //when show_all is not selected then calculate the date filters
          if (
            (this as any).dateFilter.start_date &&
            (this as any).dateFilter.end_date &&
            data.name !== DateFilterItems[0].name
          ) {
            (this as any).dateFilter.displayText =
              (this as any).dateFilter.displayText +
              " : " +
              new Date((this as any).dateFilter.start_date).toLocaleDateString(
                "en",
                dateOptions as any
              ) +
              " - " +
              new Date((this as any).dateFilter.end_date).toLocaleDateString(
                "en",
                dateOptions as any
              );
            (this as any).applyDateFilter();
            if ((this as any).isOnMobileDevice) {
              (this as any).$store.commit(
                "appModule/resetStoreVisitHistory",
                null,
                {
                  root: true,
                }
              );
              (this as any).historyTableData.pageConfig = JSON.parse(
                JSON.stringify(PageConfig)
              );
            }
          }
          break;
      }
    },
    applyDateFilter() {
      //convert the filters in the appropriate format
      (this as any).historyTableData.pageConfig.dateFilter = (this as any).dateFilter;
      (this as any).historyTableData.pageConfig.dateFilterQuery = {
        created_at__range: formatDateForQuery(
          new Date((this as any).dateFilter.start_date),
          new Date((this as any).dateFilter.end_date)
        ),
      };
      (this as any).updateRoute();
    },
    initManageHistory() {
      const parsedJSONData = JSON.parse(
        (this as any).$router.currentRoute.params.searchQuery
      );
      (this as any).searchData = parsedJSONData.search
        ? parsedJSONData.search
        : {};
      (this as any).historyTableData.pageConfig = parsedJSONData.pageConfig
        ? parsedJSONData.pageConfig
        : PageConfig;
      if (parsedJSONData.pageConfig && parsedJSONData.pageConfig.dateFilter) {
        (this as any).dateFilter = parsedJSONData.pageConfig.dateFilter;
      } else {
        (this as any).dateFilter = Object.assign(DateFilterItems[0], {
          displayText: DateFilterItems[0].display_name,
        });
      }
    },
    handleInfiniteScroll($state: any) {
      (this as any).pluginState = $state;
      if (
        (this as any).historyTableData.data &&
        (this as any).historyTableData.data.length > 0
      ) {
        (this as any).historyTableData.pageConfig.offset =
          (this as any).historyTableData.pageConfig.limit *
          (this as any).historyTableData.pageConfig.page;
        (this as any).historyTableData.pageConfig.page += 1;
        (this as any).updateRoute();
      } else {
        (this as any).pluginState.loaded();
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
    if (to.path !== from.path) {
      (this as any).initManageHistory();
      if (!(this as any).isOnMobileDevice) {
        (this as any).searchHistory();
      }
    }
  },
  mounted() {
    (this as any).initManageHistory();
  },
});
